"use client";

import Script from "next/script";

const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID?.trim();

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function GoogleAdsPixel() {
  if (!GOOGLE_ADS_ID) {
    return null;
  }

  return (
    <>
      <Script
        id="google-ads-gtag-lib"
        src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`}
        strategy="lazyOnload"
      />
      <Script
        id="google-ads-gtag-init"
        strategy="lazyOnload"
      >
        {`window.dataLayer=window.dataLayer||[];window.gtag=function(){dataLayer.push(arguments);};window.gtag('js',new Date());window.gtag('config','${GOOGLE_ADS_ID}');`}
      </Script>
    </>
  );
}
